export default __webpack_public_path__ + "static/media/Amar.9ae3fce4.png";